import { createStore } from 'vuex'
import graficoConsumoCorral from './modules/graficoConsumoCorral'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    locale: 'es', // Idioma inicial
    menuReloadKey: 0,
  },
  mutations: {
    // Cambia la visibilidad de la barra lateral entre visible/oculto
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible;
    },
    // Alterna la capacidad de desplegable de la barra lateral
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable;
    },
    // Establece un valor específico para la visibilidad de la barra lateral
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value;
    },
    // Establece el idioma actual
    setLocale(state, locale) {
      state.locale = locale
    },
    // Establece un contador para forzar la recarga del menu
    reloadMenu(state) {
      state.menuReloadKey++
    }
  },
  actions: {
    // Acción para cambiar el idioma que se encarga de ejecutar la mutación correspondiente
    changeLocale({ commit }, locale) {
      commit('setLocale', locale);
    },
    // Accion para ejecutar el cambio de menu
    triggerMenuReload({ commit }) {
      commit('reloadMenu')
    }
  },
  modules: {
    graficoConsumoCorral,
  },
});
